// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZeRj","add":"styles_add__Mp8m1","remove":"styles_remove__2Vnf7"};